import { IdType, Row as RowType } from "react-table";

import { DataSource } from "./columns";

export const globalFilterFn = (
  rows: Array<RowType<DataSource>>,
  columnIds: Array<IdType<DataSource>>,
  filterValue: any,
): Array<RowType<DataSource>> => {
  if (
    filterValue === undefined ||
    (typeof filterValue === "string" && filterValue.trim() === "")
  ) {
    return rows;
  }
  return rows.filter((row) => {
    const d = row.original;
    const fields = [
      d.destinationSchemaName,
      d.sourceConnection?.label,
      d.sourceIntegrationId,
    ];
    if (row.original.sourceIntegrationId.includes("google-sheets")) {
      fields.push(...row.original.sourceStreams.map((x) => x.name));
    }
    return fields
      .filter((value): value is string => typeof value === "string")
      .some((value) => value.toLowerCase().includes(filterValue.toLowerCase()));
  });
};

export const syncStateFilterFn = (
  rows: Array<RowType<DataSource>>,
  columnIds: Array<IdType<DataSource>>,
  filterValue: any,
): Array<RowType<DataSource>> => {
  if (filterValue == null) {
    return rows;
  }
  return rows.filter((row) => {
    const status = row.original.status;
    if (filterValue === "active") {
      return status === "RUNNING";
    }
    return status !== "RUNNING";
  });
};
